import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

// Connects to data-controller="copy-text"
export default class extends Controller {
  static targets = ['copyBtn', 'targetText', 'targetInput']
  static values = { result: String }

  copyText(e) {
    if (this.hasTargetTextTarget) {
      navigator.clipboard.writeText(this.targetTextTarget.innerText.trim())
    } else if (this.hasTargetInputTarget) {
      navigator.clipboard.writeText(this.targetInputTarget.value.trim())
    }
    this.showTooltip()
    e.preventDefault()
    e.stopPropagation() // Dropdownが閉じるのを抑制する
  }

  showTooltip() {
    const tooltip = new Tooltip(this.copyBtnTarget, {
      title: this.resultValue || 'コピーしました',
      html: true,
      placement: 'bottom',
      offset: [0, 16]
    })
    tooltip.show()

    this.copyBtnTarget.addEventListener('hidden.bs.tooltip', () => {
      tooltip.dispose()
    }, { once: true })
  }
}
